import React, { useEffect, useState } from "react";
import { Typography, Button, Drawer, Flex } from "antd";
import Logo from "./Logo";
import { useSelector } from "react-redux";

const { Title, Text } = Typography;


const AgeGate = ({ onConfirm }) => {
  const [visible, setVisible] = useState(true);
  const [screenHeight, setScreenHeight] = useState(window.innerHeight);
  const settings = useSelector((state) => state?.content?.contentData);
  const [showError, setShowError] = useState(false);
  const logo = settings?.components?.filter((c) => c.type === "heading")[0]?.logo?.url;
  const headingStyle = {
    textAlign: "center",
    marginTop: 20,
    fontStyle: "normal",
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'"
  }

  useEffect(() => {
    const handleResize = () => setScreenHeight(window.innerHeight);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleConfirm = () => {
    localStorage.setItem("ageConfirmed", "true");
    setVisible(false);
    onConfirm();
  };

  return (
    <Drawer
      open={visible}
      closable={false}
      footer={null}
      placement='top'
      centered
      zIndex={1500}
      height={screenHeight}
      style={{
        width: "100%",
        height: "100%",
        // backgroundColor: "grey",
      }}
    >
      <Flex vertical justify='center'>
        <Logo fileUrl={logo} />
        <Title level={1} style={headingStyle}>
          Welcome to {settings?.menu?.name}
        </Title>
        <Title level={3} style={headingStyle}>
          Are you 21 or older?
        </Title>

        <Flex justify='center' gap='large' style={{ margin: 20 }}>
          <Button style={{width: 100, fill: 'white'}} size='large' type="primary" onClick={handleConfirm}>
            Yes
          </Button>
          <Button style={{width: 100}} size='large' danger onClick={() => setShowError(true)}>
            No
          </Button>
        </Flex>
        <Text type="danger" strong style={{ textAlign: "center", margin: "auto", display: showError ? "block" : "none" }}>
          {showError && "You are not old enough to view this content."}
        </Text>
      </Flex>
    </Drawer>
  );
};

export default AgeGate;
